import { Button, Container, Grid, TextField, Typography, Box, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { create } from "../../redux/CrudSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function CreateProduct() {
  const [imgPreview, setImgPreview] = useState(null);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { isLoading, isCreated, isError } = useSelector(
    (state) => state.crudKey
  );
  useEffect(() => {

    !isLoading && isCreated && toast.success("Product Created successful", { autoClose: 2000, });
    setTimeout(() => {
      !isLoading && isCreated && navigate("/product-list");
    }, 2000);


  }, [isLoading, isCreated]);
  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("image", data.file[0]);
    dispatch(create(formData));
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setImgPreview(previewUrl);
    }
  };
  console.log(imgPreview);

  return (
    <>
     <Container maxWidth="xs" component={Paper} style={{paddingTop:"5px", paddingBottom:"25px", marginTop:"15px"}}>
        <Typography variant='h3' style={{ marginBottom: 25, fontWeight: "bold", textAlign: "center" }} sx={{ fontSize: { xs: '26px', sm: '30px', md: '40px' } }}>Create Product</Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid
            container
            spacing={2}
            style={{ marginTop: 10, alignItems: "center" }}
          >
            <Grid item xs={12}>
              <Typography className="label">Product Title</Typography>

              <TextField
                fullWidth
                variant="outlined"
                error={!!errors.title}
                helperText={errors.title ? "Title is required" : ""}
                {...register("title", { required: true })}
                style={{ marginBottom: 10 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className="label">Product Description</Typography>
              <TextField
                fullWidth

                variant="outlined"
                error={!!errors.description}
                helperText={errors.description ? "Description is required" : ""}
                {...register("description", { required: true })}
                style={{ marginBottom: 10 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className="label">Product Image</Typography>
              <TextField
                fullWidth
                type="file"
                variant="outlined"
                error={!!errors.file}
                helperText={errors.file ? "File is required" : ""}
                onChange={handleImageChange}
                {...register("file", { required: true })}
                style={{ marginBottom: 10 }}
                inputProps={{ accept: "image/jpeg, image/jpg" }}
              />
            </Grid>

            {
              imgPreview &&
              <Grid item xl={12}>
                <Box
                  component="img"
                  sx={{
                    width: "150px",
                    height: "110px",
                    objectFit: "cover",
                    borderRadius: 2,
                  }}
                  alt="Example Image"
                  src={imgPreview}
                />
              </Grid>
            }
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                type="submit"
                sx={{ py: 1.5, mt: 1, fontSize: "16px", fontWeight: "bold" }}
              >
                {isLoading ? "Please Wait....." : "Create Product"}
              </Button>
              {isError && <p>{isError}</p>}
            </Grid>
          </Grid>
        </form>
      </Container>
    </>
  );
}

export default CreateProduct;
